import React, { useEffect, useState } from 'react';
import { UserOutlined } from '@ant-design/icons';
import { Row, Col, Form, Input, Image, Button } from 'antd';
import { Link } from 'react-router-dom';
import AuthImg from '../../assets/img/main-banner.png';
import { Folio3AIIcon, BackArrow } from 'assets/icons';
import './scss/auth.scss';

import * as Yup from 'yup';
import axios from 'api-services/api-client';

import AuthService from 'api-services/auth-service';
import { useNavigate } from 'react-router-dom';
import useLoading from 'hooks/use-loading';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { setLoading } = useLoading();

  const [form] = Form.useForm();

  const [success, setSuccess] = useState(false);

  const emailError = 'Please enter your email address!';

  const schema = Yup.object().shape({
    email: Yup.string().email(emailError).required(emailError),
  });

  // To disable submit button at the beginning.
  useEffect(() => {
    if (AuthService.isAuthenticated()) navigate('/');
  }, []);

  const yupSync = {
    async validator({ field }, value) {
      await schema.validateSyncAt(field, { [field]: value });
    },
  };

  const validateBackend = async (values) => {
    const obj = {
      isValid: true,
      errors: [],
    };

    try {
      setLoading(true);
      await axios.post(process.env.REACT_APP_BASE_URL + 'auth/forgot/password', values);
    } catch (err) {
      obj.isValid = false;

      if (err.response.data.errors.email === 'emailNotExists') {
        obj.errors.push({
          name: 'email',
          value: values.email,
          errors: ['Invalid Email'],
        });
      }
    } finally {
      setLoading(false);
    }

    return obj;
  };

  const onFinish = async (values) => {
    setSuccess(false);
    const validationResult = await validateBackend(values);

    if (validationResult.isValid) {
      setSuccess(true);
    } else {
      form.setFields(validationResult.errors);
    }
  };

  return (
    <Row className='auth-container'>
      <Col span={10} className='auth-form-container'>
        <div>
          <a href='/' target='_blank' title='Chat Buddy Pro'>
            <Folio3AIIcon />
          </a>
          <h2>Forgot Password</h2>

          <Form id='forgot-password' form={form} size='large' name='horizontal_login' layout='vertical' onFinish={onFinish}>
            {!success ? (
              <>
                <Form.Item label='Email Address' name='email' rules={[yupSync]}>
                  <Input prefix={<UserOutlined className='site-form-item-icon' />} placeholder='Enter Email Address' />
                </Form.Item>

                <Form.Item shouldUpdate className='action-btn'>
                  {() => (
                    <Button
                      type='primary'
                      htmlType='submit'
                      disabled={!!form.getFieldsError().filter(({ errors }) => errors.length).length}>
                      Reset Password
                    </Button>
                  )}
                </Form.Item>
              </>
            ) : (
              <p>An email has been sent to you containing the reset link!</p>
            )}
            <Form.Item className='action-btn'>
              <Link to={'/login'}>
                <Button type='light' className='d-center'>
                  <BackArrow />
                  Back to Login
                </Button>
              </Link>
            </Form.Item>
          </Form>
        </div>
      </Col>
      <Col span={14} className='auth-cover'>
        <div>
          <Image preview={false} src={AuthImg} />
        </div>
      </Col>
    </Row>
  );
};

export default ForgotPassword;
